import { felixmateIconDataUri } from '@felix/domain';
import { FELIXMATE_COMPACT_ASPECT, FELIXMATE_COMPACT_PNG } from './brand/felixmate-compact-pdf.js';

/** PDF başlığındaki logo kolonu (pdfmake `image`). */
export interface PdfLogoColumn {
  image: string;
  fit: [number, number];
  width: number;
}

/** Felixmate renkli kompakt logosunun PDF'teki yüksekliği (pt). */
const PRODUCT_HEIGHT = 26;

/**
 * PDF başlığının logosu (docs/logo-degisimi.md "Hangi yerde hangisi"; ADR 0057 §7):
 *
 * - şirketin PNG ya da JPEG logosu, verilen kutuya sığdırılır (müşteri markası; ADR 0019 §4);
 * - şirketin logosu yoksa ya da logo Felixmate işaretiyse (tanıtım) renkli kompakt Felixmate;
 * - şirketin SVG/WebP logosu basılamaz (pdfmake); yerine Felixmate konmaz, kolon boş kalır.
 */
export function pdfBrandLogo(
  brand: { logo?: string | null } | null,
  box: { fit: [number, number]; width: number },
): PdfLogoColumn | null {
  const logo = brand?.logo ?? null;
  if (logo && /^data:image\/(png|jpeg);base64,/.test(logo)) return { image: logo, ...box };
  if (!logo || logo === felixmateIconDataUri()) {
    const width = Math.ceil(PRODUCT_HEIGHT * FELIXMATE_COMPACT_ASPECT);
    return { image: FELIXMATE_COMPACT_PNG, fit: [width, PRODUCT_HEIGHT], width: width + 4 };
  }
  return null;
}
